import request from '@/utils/request'
import qs from "qs";

export function list(data) {
  data=qs.stringify(data)
  return request({
    url: '/FreeQuery?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}
export function detail(data) {
  data=qs.stringify(data)
  return request({
    url: '/Get?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}
export function love(data) {
  data=qs.stringify(data)
  return request({
    url: '/ChangeNumber?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}
export function updateAll(data) {
  data=qs.stringify(data)
  return request({
    url: '/FreeUpdate?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}

